import { render, staticRenderFns } from "./DetailCourse.vue?vue&type=template&id=719c4381&"
import script from "./DetailCourse.vue?vue&type=script&lang=js&"
export * from "./DetailCourse.vue?vue&type=script&lang=js&"
import style0 from "./DetailCourse.vue?vue&type=style&index=0&id=719c4381&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports